/**
 * 全角英数記号（U+FF01-FF5E）を対応する半角文字（U+0021-007E）に変換する。
 * 1文字1文字の固定オフセット変換のため文字数は変わらない。
 * ひらがな/カタカナの変換は対象外（`toKatakana`が別途担う）。NFKCは文字数が変わる
 * 場合がありハイライト位置計算に使うと破綻するため採用しない。
 */
export const toHalfWidthAscii = (s: string): string =>
  s.replace(/[！-～]/g, (c) => String.fromCharCode(c.charCodeAt(0) - 0xfee0));

/**
 * ひらがな（U+3041-3096）を対応するカタカナ（U+30A1-30F6）に変換する。
 * 濁点・半濁点・拗音・促音を含め固定オフセット(+0x60)変換のため文字数は変わらない。
 * 半角カタカナは対象外（濁点が別文字として合成され、変換すると文字数が変わりうるため）。
 */
export const toKatakana = (s: string): string =>
  s.replace(/[ぁ-ゖ]/g, (c) => String.fromCharCode(c.charCodeAt(0) + 0x60));

/**
 * 検索用に正規化する（全角英数記号→半角 + ひらがな→カタカナ + 小文字化）。
 * 大文字小文字・全角半角・ひらがなカタカナを無視した一致判定に使う
 * （バックエンドのLIKE検索がテーブルのcollation(utf8mb4_unicode_ci)により
 * これらを同一視するのと挙動を揃えるため。実機検証済み）。
 */
export const normalizeForSearch = (s: string): string => toKatakana(toHalfWidthAscii(s)).toLowerCase();
